updateURL